var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckIn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78.626,
    height: 56.048,
    viewBox: "0 0 78.626 56.048",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Check-In",
    transform: "translate(-480.764 -193.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(521 194)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M44.583,0H8.684a.264.264,0,0,0-.078.008A.477.477,0,0,0,8.5.016a1.2,1.2,0,0,0-.117.031.438.438,0,0,0-.094.031.33.33,0,0,0-.109.047A.259.259,0,0,0,8.1.173C8.067.2,8.028.22,8,.243s-.055.039-.078.063-.055.063-.078.086S7.8.432,7.779.463a.65.65,0,0,0-.055.1.828.828,0,0,0-.055.086c-.016.039-.031.086-.047.118L7.6.84V.863a.782.782,0,0,0-.023.118c0,.039-.008.078-.008.11,0,.008-.008.016-.008.031V49.089c0,.008.008.024.008.031,0,.047.008.086.008.118s.016.078.023.11a.071.071,0,0,1,.008.039.06.06,0,0,0,.016.031,1.043,1.043,0,0,0,.14.3c0,.008.008.016.016.024a1.4,1.4,0,0,0,.211.22c.016.016.031.024.047.039a1.077,1.077,0,0,0,.265.141l.07.024a.987.987,0,0,0,.3.047.008.008,0,0,1,.008.008h35.9A1.129,1.129,0,0,0,45.7,49.1V1.122A1.119,1.119,0,0,0,44.583,0ZM9.8,2.574l23.327,6.05V41.046L9.8,47.614ZM43.467,47.967H16.824l17.723-4.991a1.124,1.124,0,0,0,.819-1.083V7.745a1.13,1.13,0,0,0-.843-1.091L17.5,2.252H43.467Z",
    transform: "translate(-7.56)",
    fill: "#3d4977",
    stroke: "#3d4977",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M46.219,2.87V48.593H19.43L37.25,43.6a1.125,1.125,0,0,0,.824-1.083V8.363a1.131,1.131,0,0,0-.847-1.091L20.113,2.87Z",
    transform: "translate(-10.324 -0.618)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M10.43,3.28V48.32l23.454-6.568V9.322ZM30.769,27.526a1.122,1.122,0,0,1-2.244,0V23.532a1.122,1.122,0,0,1,2.244,0Z",
    transform: "translate(-8.178 -0.706)",
    fill: "#36c96d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M35.734,28.782v3.994a1.122,1.122,0,0,1-2.244,0V28.782a1.122,1.122,0,1,1,2.244,0Z",
    transform: "translate(-13.26 -5.956)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "MDI_run-fast",
    "data-name": "MDI / run-fast",
    transform: "translate(480.764 209.332)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Boundary",
    width: 40.466,
    height: 40.466,
    fill: "#36c96d",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_run-fast",
    "data-name": "Path / run-fast",
    d: "M26.448,8.244a3.372,3.372,0,1,0-3.372-3.372,3.372,3.372,0,0,0,3.372,3.372m-6.07,23.437,1.686-7.419,3.541,3.372V37.751h3.372V25.105l-3.541-3.372,1.012-5.058a12.3,12.3,0,0,0,9.274,4.215V17.518a8.285,8.285,0,0,1-7.25-4.047l-1.686-2.7a3.389,3.389,0,0,0-2.866-1.686c-.506,0-.843.169-1.349.169L13.8,12.965V20.89h3.372V15.157l3.035-1.18-2.7,13.657L9.25,25.948l-.674,3.372,11.8,2.361M5.372,14.146a1.686,1.686,0,1,1,0-3.372H10.43v3.372H5.372M7.058,7.4a1.686,1.686,0,0,1,0-3.372h8.43V7.4H7.058M3.686,20.89a1.686,1.686,0,1,1,0-3.372H10.43V20.89Z",
    transform: "translate(1.372 0.186)",
    fill: "#36c96d"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIn);
export default __webpack_public_path__ + "static/media/Check-In.9646330f97752f2be4b26902b3930df7.svg";
export { ForwardRef as ReactComponent };